import { Switch, Route, Redirect, useRouteMatch } from 'peach/router'

import CreateMonitoringService from './CreateMonitoringService'
import MonitoringService from './MonitoringService'
import MonitoringServices from './MonitoringServices'

const MonitoringServicesRoutes = () => {
  const { path, url } = useRouteMatch()

  return (
    <Switch>
      <Route exact path={path}>
        <MonitoringServices />
      </Route>

      <Route path={`${path}/create`}>
        <CreateMonitoringService />
      </Route>

      <Route path={`${path}/:serviceId`}>
        <MonitoringService />
      </Route>

      <Redirect to={url} />
    </Switch>
  )
}

export default MonitoringServicesRoutes
